export const classes = {
  card: 'w-full flex justify-between items-start gap-2 px-6 py-4 shrink-0 bg-gradient-to-br from-white from-30% to-blue-200/30 dark:bg-none dark:bg-white/[0.04]',
  infoWrapper: 'flex gap-4 items-center',
  iconWrapper: 'h-12 w-12 rounded-xl bg-orange-3 shadow-card place-center',
  icon: 'text-white h-6 w-6',
  name: 'font-bold text-xl text-grey-8 dark:text-mauve-1 mb-1',
  description: 'mt-2 text-sm text-grey-7 dark:text-mauve-2 font-normal',
  controls: 'flex items-center gap-4',
  button: 'flex items-center gap-2 py-1',
  closeIcon: 'text-taupe-2 dark:text-mauve-2',
};
